var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.preview
  }, [_c('base-icon', {
    directives: [{
      name: "p-t",
      rawName: "v-p-t",
      value: 4,
      expression: "4"
    }, {
      name: "color",
      rawName: "v-color:black-2",
      arg: "black-2"
    }],
    attrs: {
      "name": "basic_user"
    }
  })], 1), _c('div', {
    directives: [{
      name: "grow",
      rawName: "v-grow"
    }]
  }, [_c('div', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "align",
      rawName: "v-align",
      value: {
        items: 'flex-start'
      },
      expression: "{ items: 'flex-start' }"
    }]
  }, [_c('div', {
    directives: [{
      name: "word-break",
      rawName: "v-word-break:break-word",
      arg: "break-word"
    }]
  }, [_vm.sender.name ? _c('div', {
    class: _vm.$style.name,
    domProps: {
      "textContent": _vm._s(_vm.sender.name)
    }
  }) : _vm._e(), _vm.sender.email ? _c('div', {
    class: _vm.$style.email
  }, [_c('base-link', {
    directives: [{
      name: "color",
      rawName: "v-color:violet",
      arg: "violet"
    }, {
      name: "text-decoration",
      rawName: "v-text-decoration:underline",
      arg: "underline"
    }],
    attrs: {
      "href": "mailto:".concat(_vm.sender.email)
    }
  }, [_vm._v(" " + _vm._s(_vm.sender.email) + " ")])], 1) : _vm._e(), _vm.sender.phone ? _c('div', {
    class: _vm.$style.phone,
    domProps: {
      "textContent": _vm._s(_vm.sender.phone)
    }
  }) : _vm._e(), _vm.sender.description ? _c('div', {
    class: _vm.$style.description,
    domProps: {
      "textContent": _vm._s(_vm.sender.description)
    }
  }) : _vm._e()]), _vm.rating && !_vm.isEmptySender ? _c('div', {
    class: _vm.$style.rating
  }, [_c('transaction-rating', {
    attrs: {
      "rating": _vm.rating
    }
  })], 1) : _vm._e()]), _vm.payment ? [!_vm.isEmptySender ? _c('hr', {
    class: _vm.$style.delimiter
  }) : _vm._e(), _c('div', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "align",
      rawName: "v-align",
      value: {
        items: 'flex-start'
      },
      expression: "{ items: 'flex-start' }"
    }]
  }, [_vm.cryptoAccrualCount > 0 ? _c('div', [_c('base-link', {
    directives: [{
      name: "color",
      rawName: "v-color:violet",
      arg: "violet"
    }, {
      name: "text-decoration",
      rawName: "v-text-decoration:underline",
      arg: "underline"
    }],
    attrs: {
      "href": _vm.cryptoTransactionHistoryLink,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.displayCryptoAccrual) + " ")])], 1) : _c('payment-method', {
    attrs: {
      "payment-method": _vm.payment.paymentMethod,
      "account-number": _vm.payment.accountNumber,
      "card-ps-type": _vm.payment.cardPsType
    }
  }), _vm.rating && _vm.isEmptySender ? _c('div', {
    class: _vm.$style.rating
  }, [_c('transaction-rating', {
    attrs: {
      "rating": _vm.rating
    }
  })], 1) : _vm._e()], 1)] : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }